<template>
		<div class="content wrap-page">
		<Header></Header>
			<div class="info crfff">

        <div style="text-align: center">
          <div style="display: inline-flex; align-items: center; justify-content: center; gap: 10px">
            <span class="fs50 w-title ac">{{$t('books')}}</span>
            <div @click="getToNav('bookRule')" style="cursor: pointer">
              <img width="70" src="../../static/images/i.png" />
            </div>
          </div>
        </div>
        <div class="tab-content mt50">
          <div class="nav-tab">
            <span class="tab-li" @click="clickTab(key)" :class="{'btn-purple':active==key}" v-for="(item,key,index) in redeemList"><span>{{item.type_name}}</span></span>
          </div>
          <div class="books-content">
            <div class="books-block disflex" style="justify-content: center;" v-for="(item,key,index) in redeemList" v-if="active==key">
              <div class="books-li" style="justify-content: center;" v-for="(item1,index1) in item.list">
                <div class="li-block por ac">
                  <div class="level">{{item1.level}}</div>
                  <div class="yuan yuan2" v-if="item1.has_book>0">{{item1.has_book}}</div>
                  <img :src="item1.image">
                  <div class="block2-font">
                    <div class="font" style="font-size: 38px">{{item1.name}}</div>
                  </div>
                </div>
                <div class="upgrade btn-green" @click="getUpgrade(1,item1)"><span>{{$t('Upgrade')}}<img v-if="item1.can_upgrade" src="../../static/images/Upgrade.png"></span></div>
              </div>
            </div>
          </div>
        </div>

        <div class="home-bottom disflex">
          <div class="bt-icon1 active" @click="getToNav('book')">
            <img style="margin-top: -30px;" src="../../static/images/mb-ic1-h.png">
            <span class="">{{$t('books')}}</span>
          </div>
          <div class="bt-icon1" @click="getToNav('bank')">
            <img src="../../static/images/mb-ic2.png">
            <span class="">{{$t('bank')}}</span>
          </div>
          <div class="bt-icon1 bt-icon2" @click="getToNav('')">
            <img src="../../static/images/mb-ic3.png">
            <span class="">{{$t('home')}}</span>
          </div>
          <div class="bt-icon1" @click="getToNav('shop')">
            <img src="../../static/images/mb-ic4.png">
            <span class="">{{$t('shop')}}</span>
          </div>
          <div class="bt-icon1" @click="getToNav('language')">
            <img src="../../static/images/mb-ic5.png">
            <span class="">{{$t('Settings')}}</span>
          </div>
        </div>
        <Dialog ref="bookDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
            <div class="" slot="mdBox">
              <div class="answer-modal invitation-dialog por">
              <div class="close ar" style="position: absolute;right:-20px;top:-20px" @click="cancelBookDialog"><img src="../../static/images/close.png"></div>
                	<div class="">
                    <div class="fs50 mt20 ac">{{$t('bookTips1')}}</div>
                    <div class="fs33 mt20 ac">{{upgradeInfo.upgrade.tip}}</div>
                    <div class="up-img ac mt30">
                      <img :src="upgradeInfo.icon_image">
                    </div>
                    <div class="Costs mt20">
                      {{$t('Costs')}}<img class="ml10" width="40" src="../../static/images/hd-ic3.png">
                      {{upgradeInfo.upgrade.need_points}}<img class="ml10" width="40" src="../../static/images/hd-ic2.png">{{upgradeInfo.upgrade.need_book}}
                    </div>
                	</div>
                <div class="mt30 disflex">
                  <button class="btn btn-red" style="width: auto;min-width: 250px;" @click="cancelBookDialog"><span>{{$t('Cancel')}}</span></button>
                  <button class="btn btn-green" style="width: auto;min-width: 250px;" @click="getUpgrade(2)"><span>{{$t('Upgrade')}}</span></button>
                </div>
              </div>
            </div>
        </Dialog>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        redeemList:[],
        active:'general',
        upgradeInfo:{
          upgrade:{
            tip:''
          }
        }
      }
    },
	created(){
    this.getRedeem()
	},
  methods: {

    getToNav(url){
      this.$router.push({path:'/'+url});
    },
		back(){
			this.$router.go(-1);
      // this.$router.push({path:'/land',query: {msisdn:this.$route.query.mobile}});
		},
    clickTab(item){
      this.active = item
    },
    getUpgrade(type,item){
      console.log(type)
      if(type==1){
        if(!item.can_upgrade){
          this.$utils.alertText(this.$t('bookTips2'),80, 1000);
          return;
        }
        this.upgradeInfo = item
        this.$refs.bookDialog.showMaskFun();
      }else{
       let data = {
          type_id:this.upgradeInfo.id
        }
        this.$parent.loadModal(true);
        this.$api.post('/api/book/upgrade',data,r =>{
          this.$utils.alertText(r.msg,80, 1000);
          this.getRedeem()
          this.$parent.loadModal(false);
        })
      }

    },
    cancelBookDialog(){
      this.$refs.bookDialog.closeMask();
    },
    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/book/list',null,r =>{
        that.redeemList = r.data
        that.$parent.loadModal(false);
      })
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/book.vue